module.exports = __webpack_public_path__ + "img/icon-regionsearch-3e314522.svg";